export default __webpack_public_path__ + "static/media/Flag_of_Azerbaijan.ee6ecdaa.svg";